import { History as HistoryIcon } from "lucide-react";

export default function History({ items }) {
  return (
    <section className="card p-5 fade-up" data-testid="history-card">
      <div className="caption flex items-center gap-2"><HistoryIcon className="h-3.5 w-3.5" /> Ostatnio grane</div>
      {!items?.length ? (
        <p className="text-sm text-slate-500 mt-4" data-testid="history-empty">Historia pojawi się po odtworzeniu pierwszego utworu.</p>
      ) : (
        <ul className="mt-3 space-y-2 max-h-64 overflow-y-auto">
          {items.map((t, i) => (
            <li key={t.played_at + i} className="flex items-center gap-3" data-testid={`history-item-${i}`}>
              {t.artwork ? <img src={t.artwork} alt="" className="h-8 w-8 rounded object-cover" /> : <div className="h-8 w-8 rounded bg-slate-800" />}
              <div className="min-w-0 flex-1">
                <a href={t.uri} target="_blank" rel="noreferrer" className="text-sm truncate block hover:text-emerald-300">{t.title}</a>
                <div className="text-[11px] text-slate-500 font-mono">{new Date(t.played_at).toLocaleString("pl-PL")}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
